import React from "react";

const PointOfUseIcon = ({ width, height, color }) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5556 0H3.44444C1.55 0 0.0172222 1.55 0.0172222 3.44444L0 27.5556C0 29.45 1.55 31 3.44444 31H27.5556C29.45 31 31 29.45 31 27.5556V3.44444C31 1.55 29.45 0 27.5556 0ZM27.5556 27.5556H3.44444V3.44444H27.5556V27.5556ZM12.9167 24.1111H18.0833V18.0833H24.1111V12.9167H18.0833V6.88889H12.9167V12.9167H6.88889V18.0833H12.9167V24.1111Z"
        fill="#ffff"
      />
    </svg>
  );
};

export default PointOfUseIcon;
